import '../../../less/ss-common-data.less';
import '../../../less/ss-common-data-ie.less';
import '../../../less/ss-application-guide.less';
import moment from 'moment';
import { Collapse, Card, Row, Col, Divider } from 'antd';
import { injectLinkConfig } from '../../../utils/helpUtils';
import MarkdownIt from 'markdown-it';
import H2R from 'html-to-react';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

let
h2r = H2R.Parser(),
md = new MarkdownIt();


const
{ getDataType } = ssCommonUtils,
DATE_FORMAT = 'MM-DD-YYYY';

class DataEntry extends React.Component {
    state = { display: 'none' }
    constructor(props) { super(props); }
    componentDidMount() {
        const { elementId } = this.props;
        injectLinkConfig(elementId.substring(0, elementId.length -2));
        setTimeout(() => this.changeDisplay('inherit'), 1000);
    }

    changeDisplay = display => this.setState({...this.state, display });

    render() {
        const
        { display } = this.state,
        { _key, entryData, collapsed, theme, elementId } = this.props,
        { text, textDescription, date, textType } = entryData;
        return (
            <Collapse
                bordered={false}
                defaultActiveKey={collapsed ? null : [ _key ]}
                style={{ backgroundColor: theme === 'light' ? '#fff' : '#222' }}
            >
                <Collapse.Panel
                    showArrow={false}
                    key={_key}
                    style={{
                        display,
                        textAlign: 'left',
                        background: theme === 'light' ? 'rgb(50, 101, 152)' : 'rgb(20, 71, 122)',
                        borderColor: theme === 'light' ? 'rgb(20, 71, 122)' : 'rgb(50, 101, 152)',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderRadius: '10px',
                        marginBottom: '20px',
                        overflow: 'hidden',
                        boxShadow: 'rgb(0, 0, 0) 0px 0px 10px'
                    }}
                    header={(
                        <div className='ss-notice-entry-title'>
                            {textDescription}
                            {textType !== 'WN' ? null : (
                                <div className='ss-notice-entry-date'>
                                    {moment(date).format(DATE_FORMAT)}
                                </div>
                            )}
                        </div>
                    )}
                >
                    <div className='ss-notice-content'>
                        <div id={elementId} className='ss-notice-html'>
                                {h2r.parse(text)}

                        </div>
                    </div>
                </Collapse.Panel>
            </Collapse>
        );
    }
}

export default class DataSet extends React.Component {
    getNoticesDataTheme = () => {
        const { space, theme } = this.props;
        let styleClass = '';

        switch(space) {
            case 'xl': styleClass += 'ss-notice-body-xl'; break;
            case 'lg': styleClass += 'ss-notice-body-lg'; break;
            case 'home-page': styleClass += 'ss-notice-body-home-page'; break;
            case 'popover': styleClass += 'ss-notice-body-popover'; break;
            default: styleClass += 'ss-notice-body-normal';
        }

        styleClass += ' ';
        switch(theme) {
            case 'light': styleClass += 'ss-notice-body-theme-light'; break;
            case 'dark': styleClass += 'ss-notice-body-theme-dark'; break;
            default: styleClass += 'ss-notice-body-theme-light';
        }

        return styleClass;
    }

    getNoticeTitle = () => {
        const { space, theme } = this.props;
        let styleClass = '';

        switch(space) {
            case 'xl': styleClass += 'ss-notice-title-xl'; break;
            case 'home-page': styleClass += 'ss-notice-title-home-page'; break;
            case 'popover': styleClass += 'ss-notice-title-popover'; break;
            default: styleClass += 'ss-notice-title';
        }

        styleClass += ' ';
        switch(theme) {
            case 'light': styleClass += 'ss-notice-title-theme-light'; break;
            case 'dark': styleClass += 'ss-notice-title-theme-dark'; break;
            default: styleClass += 'ss-notice-title-theme-light';
        }

        return styleClass;
    }

    getSpacingClass = () => {
        const { space } = this.props;
        switch(space) {
            case 'lg': return 'ss-notice-container-lg';
            case 'xl': return 'ss-notice-container-xl' ;
            case 'home-page': return 'ss-notice-container-home-page';
            case 'popover': return 'ss-notice-container-popover';
            default: return 'ss-notice-container';
        }
    }

    getNoticeClasses = () => {
        const
        { space, theme } = this.props,
        lightClasses = {
            container: 'ss-site-notice-container-light',
            noticeContainer: 'ss-notice-list-container-light',
            noticeHeader: 'ss-notice-container-header-light',
            notice: 'ss-site-notice-entry'
        };

        switch(theme) {
            case 'light': return lightClasses;

            case 'dark': return {
                container: 'ss-site-notice-container-dark',
                noticeContainer: 'ss-notice-list-container-dark',
                noticeHeader: 'ss-notice-container-header-dark',
                notice: 'ss-site-notice-entry'
            }

            default: return lightClasses;
        }
    }

    // [ABOUT]
    // This is EXCLUSIVELY for supporting IE 11. That garbage browser should, ultimately
    // NOT be used, but try convincing the ancients of that. IE has LESS THAN 5% of the
    // market, but they push for this type of garbage. It is beyond me, but here this
    // garbage is.
    getIENoticeStyles() {
        let
        // Internet Explorer 6-11
        isIE = /*@cc_on!@*/false || !!document.documentMode,
        styles = {
            ieDataTheme: {}
        };

        if (!isIE) return {...styles};
        else return {...styles,
            ieDataTheme: { height: window.innerHeight - 324 }
        };
    }

    render() {
        const
        { type, title, portal, data, sort, collapsed, space, theme, elementId, format, siteNotice } = this.props,
        noticesClasses = this.getNoticeClasses(),
        ieNoticeStyles = this.getIENoticeStyles();
        let keyPrefix, dataSet = [], notices = [];

        // Make sure that each entry has the proper portal type in its array.
        for(let d in data)
            if(data[d].portalTypes.indexOf(portal) !== -1)
                dataSet.push(data[d]);

        for(let s in siteNotice)
            if(siteNotice[s].portalTypes.indexOf(portal) !== -1)
                notices.push(siteNotice[s]);

        // Call sort function is defined.
        if(sort != null && getDataType(sort) === 'Function')
           { dataSet.sort((a, b) => sort(a, b));
             notices.sort((a, b) => sort(a, b))
           }

        if(type==='WN' && dataSet.length>0)
        {
            let subArr = [];
            subArr=dataSet.splice((dataSet.findIndex(obj => obj.textDescription==="Contact Information")), 1);
            dataSet.push(subArr[0]);
        }


        switch(type) {
            case 'WN':
                keyPrefix = 'whats-new-';
                break;

            case 'LEG':
                keyPrefix = 'regulatory-';
                break;

            case 'LN':
                keyPrefix = 'legal-notices-';
                break;

            case 'FAQ':
                keyPrefix = 'faq-';
                break;

            case 'GUIDE':
                keyPrefix = 'app-guide-';
                break;

            case 'LINK':
                keyPrefix = 'links-';
                break;

            case 'CNTC':
                keyPrefix = 'contact-afsp-';
                break;

            default: return null;
        }



        return (
            <div className={this.getSpacingClass()}>
                <div className={this.getNoticeTitle()}>
                    {title}
                </div>
                <div className={this.getNoticesDataTheme()} style={ieNoticeStyles.ieDataTheme}>
                    {type !== 'WN' ? null : notices.length === 0 ? null : (
                        <div className={noticesClasses.container}>
                            <div className={noticesClasses.noticeHeader}>
                                {'Notice(s)'}
                            </div>
                            <div className={noticesClasses.noticeContainer}>
                                {notices.map((n, i) => (
                                    <div key={`site-notices-${type}${i}`} className={noticesClasses.notice}>
                                        <Row>
                                            <Col>
                                                <div className='ss-notice-entry-title-site-notice'>
                                                    {h2r.parse(md.render(n.textDescription))}
                                                </div>
                                                <div className='ss-notice-entry-date-site-notice'>
                                                    {n.date ? moment(n.date).format('YYYY-MMM-DD, HH:mm:ss') : ''}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Divider type='horizontal' style={{ margin: '10px 0px' }} />
                                        <div>
                                            {h2r.parse(md.render(n.text))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {dataSet.map((e, i) => (<DataEntry
                        key={`${keyPrefix}-${i}`}
                        _key={`${keyPrefix}${i}`}
                        elementId={`${elementId}-${i}`}
                        collapsed={!!collapsed}
                        entryData={e}
                        theme={theme}
                    />))}
                </div>
            </div>
        );
    }
}
